import { rd } from '@passionware/monads';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Loading } from 'v1/components/shared';
import NotFoundScreen from 'v5/features/core/not-found/NotFoundScreen.connected';
import { myAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService.connected';

/**
 * Unknown workspace/team slugs fail scope resolution. Without this gate,
 * feature-flag / access hooks treat failure as “still pending” and spin forever.
 */
export function ResolvedAppScopeGate({ children }: { children: ReactNode }) {
  const scopeRd = myAppScopeService.useResolvedAppScope();
  const slugScope = myAppScopeService.useSlugAppScope();
  const { t } = useTranslation('core', { keyPrefix: 'not_found' });

  return rd
    .journey(scopeRd)
    .wait(<Loading className="pageCenter" />)
    .catch(() => {
      if (slugScope.level === 'team') {
        return (
          <NotFoundScreen
            title={t('team.title')}
            description={t('team.description')}
          />
        );
      }
      if (slugScope.level === 'workspace') {
        return (
          <NotFoundScreen
            title={t('workspace.title')}
            description={t('workspace.description')}
          />
        );
      }
      return <NotFoundScreen />;
    })
    .map(() => children);
}
